<ng-container
  *ngIf="
    (loader.profileLoader$ | async) ||
      (loader.organizationLoader$ | async) ||
      (langLoader.langLoader$ | async);
    else content
  "
>
  <ui-page-loader class="page-loader"></ui-page-loader>
</ng-container>

<div class="hidden">{{ "" | translate }}</div>

<ng-template #content>
  <router-outlet></router-outlet>
</ng-template>

<core-organization-switch-modal
  *ngIf="showOrgSelection && !(profile.organization$ | async)"
  [isVisible]="true"
  [organizationList]="orgList"
  (organizationChange)="organizationChange($event)"
></core-organization-switch-modal>
